import { Ethnicity, Race } from "../../../@types";
import { ChoiceState, Option } from "./types";

export const ethnicityOptions: Option[] = [
  {
    labelKey:
      "enroll_form.ethnicity.not_hispanic_or_latino_latina_or_spanish_origin",
    value: Ethnicity.ETHNICITY_NOT_HISPANIC_OR_LATINO_LATINA_OR_SPANISH_ORIGIN,
  },
  {
    labelKey: "enroll_form.ethnicity.puerto_rican",
    value: Ethnicity.ETHNICITY_PUERTO_RICAN,
  },
  {
    labelKey: "enroll_form.ethnicity.another_hispanic_latino_or_spanish_origin",
    value: Ethnicity.ETHNICITY_ANOTHER_HISPANIC_LATINO_OR_SPANISH_ORIGIN,
  },
  {
    labelKey:
      "enroll_form.ethnicity.mexican_or_mexican_american_or_chicano_chicana",
    value: Ethnicity.ETHNICITY_MEXICAN_OR_MEXICAN_AMERICAN_OR_CHICANO_CHICANA,
  },
  {
    labelKey: "enroll_form.ethnicity.cuban",
    value: Ethnicity.ETHNICITY_CUBAN,
  },
  {
    labelKey: "enroll_form.i_choose_not_to_answer",
    value: Ethnicity.ETHNICITY_I_CHOOSE_NOT_TO_ANSWER,
  },
];

export const raceOptions: Option[] = [
  {
    labelKey: "enroll_form.race.american_indian_or_alaska_native",
    value: Race.RACE_AMERICAN_INDIAN_OR_ALASKA_NATIVE,
  },
  {
    labelKey: "enroll_form.race.asian_indian",
    value: Race.RACE_ASIAN_INDIAN,
  },
  {
    labelKey: "enroll_form.race.black_or_african_american",
    value: Race.RACE_BLACK_OR_AFRICAN_AMERICAN,
  },

  {
    labelKey: "enroll_form.race.chinese",
    value: Race.RACE_CHINESE,
  },

  {
    labelKey: "enroll_form.race.filipino",
    value: Race.RACE_FILIPINO,
  },

  {
    labelKey: "enroll_form.race.guamanian_or_chamorro",
    value: Race.RACE_GUAMANIAN_OR_CHAMORRO,
  },

  {
    labelKey: "enroll_form.race.japanese",
    value: Race.RACE_JAPANESE,
  },

  {
    labelKey: "enroll_form.race.korean",
    value: Race.RACE_KOREAN,
  },
  {
    labelKey: "enroll_form.race.native_hawaiian",
    value: Race.RACE_NATIVE_HAWAIIAN,
  },
  {
    labelKey: "enroll_form.race.other_asian",
    value: Race.RACE_OTHER_ASIAN,
  },
  {
    labelKey: "enroll_form.race.other_pacific_islander",
    value: Race.RACE_OTHER_PACIFIC_ISLANDER,
  },
  {
    labelKey: "enroll_form.race.samoan",
    value: Race.RACE_SAMOAN,
  },
  {
    labelKey: "enroll_form.race.vietnamese",
    value: Race.RACE_VIETNAMESE,
  },
  {
    labelKey: "enroll_form.race.white",
    value: Race.RACE_WHITE,
  },
  {
    labelKey: "enroll_form.i_choose_not_to_answer",
    value: Race.RACE_I_CHOOSE_NOT_TO_ANSWER,
  },
];

export const createChoiceState = (
  options: Option[],
  selectedValues: string[],
  t: (id: string) => string
): ChoiceState[] => {
  return options.map(o => {
    return {
      label: t(o.labelKey),
      value: o.value,
      checked: selectedValues.includes(o.value),
    };
  });
};

export const getSelectedLabels = (
  selectedValues: string[],
  options: Option[],
  t: (id: string) => string
): string[] => {
  if (selectedValues.length == 0) {
    return [];
  }
  return options.reduce((acc: string[], opt: Option) => {
    if (selectedValues.includes(opt.value)) {
      acc.push(t(opt.labelKey));
    }
    return acc;
  }, []);
};
